import { ArrowDownRight, ArrowUpRight } from "@phosphor-icons/react"
import { cva } from "class-variance-authority"
import { RadioGroupLabel } from "@/components/ui/radio-group"
import { RadioGroupItem } from "@/modules/patients/agenda/teleconsultation/booking/components/radio-button"
import { MappingSlot } from "@/modules/patients/agenda/teleconsultation/booking/date-slot-selector/slot-date"

interface TimeSlotListProps {
  slots: MappingSlot[]
}

const SLOT_COLUMNS = 4

const timeSlotVariants = cva("flex gap-2", {
  variants: {
    variant: {
      hasCapacity:
        "bg-success-surface-subdued! text-on-success-surface! data-[state=checked]:bg-primary-surface! hover:bg-success-surface-subdued-hovered! data-[state=checked]:hover:bg-primary-surface-hovered! focus:bg-primary-surface! focus:text-on-primary-surface!",
      noCapacity:
        "group data-[state=checked]:bg-primary-surface! data-[state=checked]:hover:bg-primary-surface-hovered! focus:bg-primary-surface! focus:text-on-primary-surface!",
    },
  },
  defaultVariants: {
    variant: "noCapacity",
  },
})

const TimeSlotList = ({ slots }: TimeSlotListProps) => {
  const startPoint = SLOT_COLUMNS - (slots.length % SLOT_COLUMNS)

  return (
    <div className="grid grid-cols-4 items-center gap-2">
      {[...Array(startPoint).keys()].map((i) => (
        <div key={-i}></div>
      ))}
      {slots.map((s) => (
        <RadioGroupItem
          key={s.slotId}
          value={String(s.slotId)}
          className={timeSlotVariants({ variant: s.available ? "hasCapacity" : "noCapacity" })}
          id={String(s.slotId)}
          disabled={!s.available && !s.allowPriorityBooking}
          data-testid={`slot-${s.slotId}`}>
          {s.available ? (
            <ArrowUpRight size={20} />
          ) : (
            <ArrowDownRight
              size={20}
              className={`${s.allowPriorityBooking && "text-critical group-focus:text-on-primary-surface group-data-[state=checked]:text-on-primary-surface"}`}
            />
          )}
          <RadioGroupLabel className="p-0" htmlFor={s.value}>
            {s.value}
          </RadioGroupLabel>
        </RadioGroupItem>
      ))}
    </div>
  )
}

export { TimeSlotList }
